import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import theme from "../../../styles/theme";
import DropdownMenuList from "../../reusable/Dropdown/DropdownMenuList";

const dropdownMenuItems = [
    { icon: "/assets/icones/shopping-bag.svg", label: "Projects", link: "/projects" },  
    { icon: "/assets/icones/share.svg", label: "Collaborate", link: "/Collaboration" },
    { icon: "/assets/icones/setting.svg", label: "Settings", link: "/settings" }, 
    { icon: "/assets/icones/sliders.svg", label: "Library", link: "/Library" },
    
  ];


const Footer = ({ indicator1, indicator2 }) => {
  return (
    <footer
      style={{
        position: "relative",  // <-- Ajoute ceci
        width: "100%",
        backgroundColor: theme.colors.background.footer,
        borderTop: theme.borders.width.thin,
        display: "flex",
        alignItems: "center", // centre verticalement
        justifyContent: "space-between", // contenu gauche ↔ droite
        fontSize: theme.fontSizes.sm,
        color: theme.colors.text.muted,
        padding: "12px 24px",
        boxSizing: "border-box",
        height: "100%",
        overflow: "visible",
        zindex: 1000
      }}
    >
      {/* Conteneur gauche : icône + indicateurs */}
      <div
        style={{ display: "flex", alignItems: "center", gap: theme.spacing.md, }}
      >
        {/* Icône principale */}
        <DropdownMenuList icon="/assets/icones/shopping-bag.svg" chevronIcon="/assets/icones/chevron-up.svg" label="" items={dropdownMenuItems}  direction="top"  iconSize={16}  chevronSize={18} />
        <img src="/assets/icones/message-square.svg" alt="Message" style={{ height: 16, width: 16 }} />
        <img src="/assets/icones/refresh.svg" alt="Synchro" style={{ height: 14, width: 14 }}
        />
        

        {/* Indicateurs */}
        <div
          style={{
            display: "flex",
            gap: theme.spacing.sm,
            
          }}
        >
          {/* Indicateur 1 */}
          <div
            style={{
              // backgroundColor: theme.colors.background.surface,
              // border: `1px solid ${theme.colors.borders.default}`,
              // borderRadius: theme.borders.radius.sm,
              // boxShadow: theme.shadows.sm,
              background: "rgba(255, 255, 255, 0.08)",   // fond légèrement différent du footer
              border: "#e2e8f0",                         // bordure
              borderRadius: "4px",                        // arrondi
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",    // ombre subtile
              backdropFilter: "blur(2px)",                // effet verre léger
              padding: "6px 12px",
              fontSize: theme.fontSizes.sm,
              color: theme.colors.text.third,
              boxShadow: theme.shadows.sm,
              minWidth: "220px",
              textAlign: "left",
           
            }}
          >
            {indicator1 || "Synchronisation en attente"}
          </div>

          {/* Indicateur 2 */}
          <div
            style={{
              // backgroundColor: theme.colors.background.surface,
              // border: `1px solid ${theme.colors.borders.default}`,
              // borderRadius: theme.borders.radius.sm,
              // boxShadow: theme.shadows.sm,
              background: "rgba(255, 255, 255, 0.08)",   // fond légèrement différent du footer
              border: "#e2e8f0",                         // bordure
              borderRadius: "4px",                        // arrondi
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",    // ombre subtile
              backdropFilter: "blur(2px)",                // effet verre léger
              padding: "6px 12px",
              fontSize: theme.fontSizes.sm,
              color: theme.colors.text.third,
              minWidth: "220px",
              textAlign: "left",
            }}
          >
            {indicator2 || "Serveur : En ligne"}
          </div>
        </div>
      </div>

      {/* Contenu à droite */}
      <span style={{ marginRight: theme.spacing.md }}>
        © 2025 Quantum Corelia
      </span>
    </footer>
  );
};

export default Footer;
